import type { LinkageRule } from '../../../platform/linkage/types';

/** AppInstance 跨能力联动 props；规则追加时在此扩展 */
export type AppInstanceLinkagePropsMap = Record<string, unknown>;

/** 暂无跨能力规则；目录与 hook 与 VM 样板同构 */
export const APP_INSTANCE_LINKAGE_RULES: LinkageRule<AppInstanceLinkagePropsMap>[] = [];
